import { Formik } from "formik";
import { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import FormDisplay from "./FormDisplay";
import pages from "../../../constants/pages";
import { useAxios, useAlert } from "../../../hooks";
import { objectFromFormData } from "./leadCampaignObject";
import { ButtonFooter, FloatingEditActionButtons } from "../../../components";

export default function Form({
  configName,
  formData,
  field,
  editState,
  setEditState,
  setFormData,
  subscriptionID,
}) {
  const axios = useAxios();
  const { alert } = useAlert();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { activeBrand } = useSelector((state) => state.memberDetails);

  return (
    <Formik
      enableReinitialize
      initialValues={formData}
      validateOnChange
      onSubmit={(formData, { setSubmitting }) => {
        formData.brandID = activeBrand.ID;
        axios({
          url: "/save/leadCampaign",
          method: "POST",
          data: objectFromFormData(formData),
        }).then((response) => {
          if (response.status) {
            setFormData(formData);

            navigate(pages.detailsLeadCampaign.route + response.data.dial_id);
          }
        });
      }}
    >
      {(formikProps) => (
        <Fragment>
          <FormDisplay
            subscriptionID={subscriptionID}
            configName={configName}
            field={field}
            editState={editState}
            formikProps={formikProps}
          />

          {!formData.freezed && (
            <FloatingEditActionButtons
              formikProps={formikProps}
              editState={editState}
              setEditState={setEditState}
              ID={formikProps.values?.subscriptionID}
            />
          )}

          <ButtonFooter
            formikProps={formikProps}
            editState={editState}
            setEditState={setEditState}
            ID={formikProps.values?.subscriptionID}
          />
        </Fragment>
      )}
    </Formik>
  );
}
